import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';

import biscuit from 'tbSrc/js/utils/cookie-handler';
import { useModal } from 'hooks';
import { lazyRetry } from 'src/js/utils';
import inx from 'inx';

const WarningModal = lazy(() => lazyRetry(() => import(
    /* webpackChunkName: "modal_trial-or-expires" */
    './PurchaseWarningModal'
), 'modal_trial-or-expires'));

const Modal = (props) => {
    const { isShowing: isModalVisible, toggle: toggleModal } = useModal(true);

    return isModalVisible && (
        <Suspense fallback=''>
            <WarningModal hide={toggleModal} {...props} />
        </Suspense>
    );
};

export function getPurchaseLink(utmParams) {
    if (!inx.params.purchase.link) {
        return null;
    }
    const [baseUrl, queryString] = inx.params.purchase.link.split('?', 2);
    let params = { ...Object.fromEntries(new URLSearchParams(queryString)), ...utmParams };

    return baseUrl + '?' + new URLSearchParams(params).toString();
}

export function getPremiumProductName() {
    return inx.i18n.product[inx.params.purchase.product_name] ?? null;
}

let modalRoot = null;

export default ({ params }) => {
    const { trialModal, expiresModal } = params;
    if (!trialModal && !expiresModal) return;
    const container = document.getElementById('purchase-modal-container');
    const biscuitNames = {
        trial: 'trialReminderShown',
        expires: 'expiresReminderShown'
    };

    if (trialModal?.reminderSec) {
        if (+biscuit.getIt(biscuitNames.trial) !== 1) {
            if (!modalRoot) {
                modalRoot = createRoot(container);
            }
            modalRoot.render(
                <Modal modalData={params} />
            );
            biscuit.setIt(biscuitNames.trial, 1, trialModal.reminderSec);
        }
    }

    if (expiresModal?.reminderSec) {
        if (+biscuit.getIt(biscuitNames.expires) !== 1) {
            if (!modalRoot) {
                modalRoot = createRoot(container);
            }
            modalRoot.render(
                <Modal modalData={params} expires />
            );
            biscuit.setIt(biscuitNames.expires, 1, expiresModal.reminderSec);
        }
    }
};